<template>
  <router-view />
</template>

<script>
export default {
  name: 'AppRoot'
}
</script>

<style>
/* Ensure body and html take up full height */
html, body, #app {
  height: 100%;
  margin: 0;
}
</style>